"use client";

import { createContext, PropsWithChildren, useContext, useState } from "react";

export type AlternateYearContextProps = {
    tourUUID?: string;
    setAlternateYearState?: React.Dispatch<
        React.SetStateAction<AlternateYearContextState>
    >;
};
export type AlternateYearContextState = {
    tourUUID: string;
};

const AlternateYearContext = createContext<AlternateYearContextProps | null>(
    null,
);

export const useAlternateYearContext = () => useContext(AlternateYearContext);

export const AlternateYearContextProvider: React.FC<
    React.PropsWithChildren<PropsWithChildren>
> = ({ children }) => {
    const [alternateYearState, setAlternateYearState] =
        useState<AlternateYearContextState>({
            tourUUID: "",
        });

    return (
        <AlternateYearContext.Provider
            value={{
                tourUUID: alternateYearState.tourUUID,
                setAlternateYearState,
            }}
        >
            {children}
        </AlternateYearContext.Provider>
    );
};
